import getUA from './getUA'

export default function (os) {
  const ver = ('' + (new RegExp(os + '(\\d+((\\.|_)\\d+)*)').exec(getUA()) || [])[1] || 0)
  // undefined < 3 === false, but null < 3 === true
  return ver || undefined
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/platform.js